export default {
    props: {
        animation: {
            type: [Object, String]
        }
    },
    mounted() {
        // TODO: get rid of magic number
        const MAGIC_SAFARI_NUMBER = 5;
        this.$refs.lottie && setTimeout(() => {
            this.$refs.lottie.load(this.animation);
        }, MAGIC_SAFARI_NUMBER);
    }
}
